/* eslint-disable */
import { produce } from "immer";
import { create } from "zustand";

import type { GiftGoldVerifyResType } from "../goldVerify";

export const GiftVerifyInitialData = {
  receiverName: "",
  receiverMobileNumber: "",
  goldValue: 0,
  gst: 0,
  goldInGrams: 0,
  totalAmountPayable: 0,
  buyLotId: "",
};
export const initialState = {
  giftdata: GiftVerifyInitialData,
};
export type GiftIntialDataType = {
  giftdata: GiftGoldVerifyResType;
};
export type GiftVerifyStoreUpdates = {
  updateGiftData: (giftdata: GiftIntialDataType["giftdata"]) => void;
};
export const useGiftVerifyStore = create<
  GiftIntialDataType & GiftVerifyStoreUpdates
>((set) => ({
  ...initialState,
  updateGiftData: (giftdata) => {
    set(
      produce((state: GiftIntialDataType) => {
        state.giftdata = giftdata;
      })
    );
  },
}));
